import { Flex } from '@servicetitan/anvil2';
import { formatAddress, PortalDrawer, usePortalMode } from '@servicetitan/cp-ui';
import { BodyText, Card, Icon } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';
import { observer } from 'mobx-react';
import { FC } from 'react';
import { ServiceAgreementCoveredLocationsDrawerStore } from '../stores/service-agreement-covered-locations-drawer.store';

export const ServiceAgreementCoveredLocationsDrawer: FC = observer(() => {
    const [{ close, coveredLocations, isOpen }] = useDependencies(
        ServiceAgreementCoveredLocationsDrawerStore
    );
    const mode = usePortalMode();

    if (!coveredLocations?.length) {
        return null;
    }

    return (
        <PortalDrawer mobile={mode.mobile} open={isOpen} title="Covered Locations" onClose={close}>
            <div>
                {coveredLocations.map(location => (
                    <Card.Section
                        key={formatAddress(location)}
                        className="p-2 m-b-1"
                        style={{ borderRadius: '6px', borderBottom: 'solid 1px #DFE0E1' }}
                    >
                        <BodyText size="small">
                            <Flex direction="row" alignItems="center">
                                <Icon
                                    color="#606162"
                                    name="place"
                                    size={32}
                                    className="m-r-half m-b-half"
                                />
                                {formatAddress(location)}
                            </Flex>
                        </BodyText>
                    </Card.Section>
                ))}
            </div>
        </PortalDrawer>
    );
});
